import Card from "@material-tailwind/react/Card";
import CardHeader from "@material-tailwind/react/CardHeader";
import CardBody from "@material-tailwind/react/CardBody";
import InputIcon from "@material-tailwind/react/InputIcon";
import DataTable from "react-data-table-component";
import Button from "@material-tailwind/react/Button";

export default function TableReferralHistoryDetail({
  data,
  pending,
  date,
  usernameEvent,
}) {

  function numberFormat(number) {

    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    //return number;
  }

  const columns = [
    {
      name: "Username",
      selector: (row) => row.username,
      sortable: true,
    },
    {
      name: "Total Turnover",
      selector: (row) => (numberFormat(row.total_turnover)),
      sortable: true,
    },
    {
      name: "Total Winlose",
      selector: (row) => (numberFormat(row.total_winlose)),
      sortable: true,
    },
    {
      name: "Bonus Turnover Percentage",
      selector: (row) => row.turnover_bonus_percentage + '%',
      sortable: true,
    },
    {
      name: "Bonus Winlose Percentage",
      selector: (row) => row.winlose_bonus_percentage + '%',
      sortable: true,
    },
    {
      name: "Turnover Bonus",
      selector: (row) => (numberFormat(row.turnover_comision)),
      sortable: true,
    },
    {
      name: "Winlose Bonus",
      selector: (row) => (numberFormat(row.winlose_comision)),
      sortable: true,
    },
  ];

  const handleExport = () => {
    const header = 'username, total turnover, total winlose, bonus turnover percentage, bonus winlose percentage, turnover bonus, winlose bonus\n';
    const csvData = data.map(d => `"${d.username}","${d.total_turnover}","${d.total_winlose}","${d.turnover_bonus_percentage}","${d.winlose_bonus_percentage}","${d.turnover_comision}","${d.winlose_comision}"\n`).join('');
    const blob = new Blob([header + csvData], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.setAttribute('download', 'bonus_referral-' + date + '.csv');
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  return (
    <>
      <Card>
        <CardBody>
          <InputIcon
            type="text"
            color="lightBlue"
            size="sm"
            outline={true}
            placeholder="Username"
            iconName="search"
            onChange={usernameEvent}
          />
        </CardBody>
      </Card>
      <Card className="mt-12">
        <CardHeader color="blueGray" contentPosition="left">
          <h2 className="text-white text-2xl">Bonus Referral</h2>
          <p>{date}</p>
        </CardHeader>
        <CardBody>
          <div className="flex gap-4">
            <Button
              onClick={handleExport}
            >
              Export To CSV
            </Button>
          </div>
          <DataTable
            columns={columns}
            data={data}
            progressPending={pending}
            pagination
          />
        </CardBody>
      </Card>
    </>
  );
}
